import type { CountryResponse } from 'api/Countries/types'
import classNames from 'classnames'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import SummaryBackTo from 'search/SummaryBackTo'
import { countryIdToString } from 'utils/countryUtils'

import ClosedReportingContainer from './ClosedReportingContainer'
import { CLOSED_REPORTING_TAB, COUNTRIES_LAST_UPDATE_TAB, COUNTRIES_LIST_TYPES } from './constants'
import CountriesTable from './CountriesTable'
import DelayedStores from './DelayedStores'
import TableStoresContainer from './TableStoresContainer'
import type { CompletenessDetailsProps } from './types'

function CompletenessDetailsContent({
  closeChannelDetails,
  countries,
  countryId,
  countryName,
  delayedStores,
  fetchCountryStoresList,
  generalRevenueData,
  isFetchingCompletenessGeneralRevenue,
  isFetchingCountries,
  isFetchingDelayedStores,
  showChannelDetails,
  todayDateChosen,
  todayGeneralRevenue,
  selectedValue,
}: CompletenessDetailsProps) {
  const { t: translate } = useTranslation()
  const generalRevenue = todayGeneralRevenue && todayGeneralRevenue.storesCurrent ? todayGeneralRevenue : generalRevenueData

  if (selectedValue === COUNTRIES_LAST_UPDATE_TAB) {
    if (countryId) {
      return (
        <>
          <div className="completeness-details_title">
            {countryName}
            <i className={classNames('flag', `flag-${countryIdToString(countryId)}`)} />
          </div>
          <SummaryBackTo onClick={closeChannelDetails} title={translate('revenue.stats.completeness.back')} />
          <TableStoresContainer countryId={countryId} />
        </>
      )
    }

    return (
      <CountriesTable
        countries={countries}
        isFetching={isFetchingCountries}
        onRowClick={(row: CountryResponse) => {
          showChannelDetails(row.countryId, row.countryNamePL)
          fetchCountryStoresList(row.countryId)
        }}
        tableType={COUNTRIES_LIST_TYPES.LATEST_REPORTS}
      />
    )
  }

  if (selectedValue === CLOSED_REPORTING_TAB) {
    return <ClosedReportingContainer todayDateChosen={todayDateChosen} />
  }

  return (
    <DelayedStores
      delayedStores={delayedStores}
      generalRevenue={generalRevenue}
      isFetchingCompletenessGeneralRevenue={isFetchingCompletenessGeneralRevenue}
      isFetchingDelayedStores={isFetchingDelayedStores}
      todayDateChosen={todayDateChosen}
      variant={selectedValue}
    />
  )
}

export default memo(CompletenessDetailsContent)
